export const ANY_DENTIST_OPTION = 'Any dentist';
export const ALL_PROVIDERS = 'all';
